// ============================================================================
// DSU ROLLBACK - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'dsu-rollback',
  name: 'DSU Rollback',
  category: 'Graphs',
  complexity: {
    time: 'O(log N)',
    space: 'O(N)'
  },
  description: 'A Disjoint Set Union (Union-Find) data structure with rollback capability. It maintains a history of operations and can revert to previous states, useful for offline dynamic connectivity problems.'
};
